import React from 'react'
    
export const CurrencyFormat = ({val=0,currency="IQD"}) => {
    return (
        new Intl.NumberFormat().format(val)
    )
}